module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('time', {
    staticClass: "clock"
  }, [_c('span', {
    staticClass: "clock__hour"
  }, [_vm._v(_vm._s(_vm.hours))]), (!_vm.blink || _vm.seconds % 2 === 0) ? _c('span', [_vm._v(":")]) : _c('span', [_vm._v(" ")]), _c('span', {
    staticClass: "clock__minutes"
  }, [_vm._v(_vm._s(_vm.minutes))]), (!_vm.blink || (_vm.seconds % 2 === 0 && _vm.displaySeconds)) ? _c('span', [_vm._v(":")]) : (_vm.displaySeconds) ? _c('span', [_vm._v(" ")]) : _vm._e(), (_vm.displaySeconds) ? _c('span', {
    staticClass: "clock__seconds"
  }, [_vm._v(_vm._s(_vm.seconds))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e3932bc0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-digital-clock/Clock.vue
// module id = 1115
// module chunks = 1